import { DragIndicator } from '@mui/icons-material';
import { Typography } from '@mui/material';
import { Row } from 'components/Layout';
import DraggableList from 'components/DraggableList';
import { Card, CardContent } from 'further-ui/components/Card';
import { Column, Divider } from 'further-ui/components/Layout';
import StepIndex from 'further-ui/components/StepIndex';

type Props = {
  label: string;
  description: string;
  index: number;
  fixed?: boolean;
};

const WaterfallStructureItem: React.FC<Props> = ({
  label,
  description,
  index,
  fixed = false,
}) => {
  return (
    <Card variant="outlined">
      <CardContent size="sm">
        <Column spacing="sm">
          <Row centered justify="space-between" spacing="sm">
            <StepIndex
              index={index + 1}
              label={<Typography variant="h6">{label}</Typography>}
            />
            {fixed ? null : (
              <DraggableList.Handle isFlexItem>
                <DragIndicator fontSize="small" />
              </DraggableList.Handle>
            )}
          </Row>
          <Divider />
          <Typography variant="body2">{description}</Typography>
        </Column>
      </CardContent>
    </Card>
  );
};

export default WaterfallStructureItem;
